function pay(paymentEvent, settings, accountId, userMail, payAmount, subName) {
  this.payWidget = function () {
    var widgetParams = {
    };
    var receipt = {
      items: [
        {
          label: subName,
          price: payAmount,
          quantity: 1,
          amount: payAmount,
          method: 4,
          object: 4
        }
      ],
      taxationSystem: 0,
      email: userMail,
      amounts: {
        electronic: payAmount
      },
    }
    var data = {};
    data.CloudPayments = {
      customerReceipt: receipt,
      recurrent: {
        period: settings.period,
        interval: 'Day',
        amount: payAmount,
        startDate: settings.isSetStartDate ? settings.startDate : undefined,
        customerReceipt: receipt,
      }
    };
    var widget = new cp.CloudPayments(widgetParams);
    widget.pay('charge',
      {
        publicId: settings.terminalId,
        description: 'Оплата подписки',
        amount: payAmount,
        currency: 'RUB',
        accountId: accountId,
        email: userMail,
        skin: "classic ",
        autoClose: 3,
        restrictedPaymentMethods: ['Dolyame', 'TinkoffPay', 'sbp'],
        requireEmail: true,
        data: data,
        configuration: {
          common: {
          }
        }
      },
      {
        onSuccess: function (options) {
        },
        onFail: function (reason, options) {
          paymentEvent(reason);
        },
        onComplete: function (paymentResult, options) {
          paymentEvent(paymentResult);
        }
      }
    )
  };

  this.payWidget();
}

const IOS = "iOS";
const ANDROID = "Android";
const MACOS = "MacOS";

function getOsName() {
  var userAgent = navigator.userAgent;
  var osName = "";

  if (userAgent.match(/Android/i)) {
    osName = ANDROID;
  }

  if (userAgent.match(/iPhone/i)) {
    osName = IOS;
  }

  if (userAgent.match(/Macintosh/i)) {
    osName = MACOS;
  }

  return osName;
}

function getOsVersion() {
  var userAgent = navigator.userAgent;
  var nVer = navigator.appVersion;
  var osVersion = "";
  var version = "";

  if (userAgent.match(/Android/i)) {
    version = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(userAgent)[1];
  }

  if (userAgent.match(/iPhone/i)) {
    osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
    version = osVersion[1] + '.' + osVersion[2];
    if (osVersion[3]) {
      version = version + '.' + osVersion[3];
    }
  }
  return version;
}

function getTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
